import React from 'react';
import PropTypes from 'prop-types';

import styles from './RoleLabel.module.scss';

const RoleLabel = ({ role, className }) => {
  if (!role) return null;

  const combinedClassName = className
    ? `${styles.roleLabel} ${className}`
    : styles.roleLabel;

  return <span className={combinedClassName}>{role}</span>;
};

RoleLabel.propTypes = {
  role: PropTypes.string,
  className: PropTypes.string,
};

export default RoleLabel;
